import {ReactComponent as Img} from '../../../../images/icons/img.svg';
import {ReactComponent as Camera} from '../../../../images/icons/camera.svg';
import { ReactComponent as Avatar } from '../../../../images/icons/avatar.svg';
import T from "../../../i18n/Text";
import React from "react";

interface Props {
    selected: boolean;
    onClick: (e:React.MouseEvent<HTMLButtonElement>) => void;
    source: PhotoSource;
}
export enum PhotoSource{
    IMG = "image",
    CAMERA = "camera",
    AVATAR = "avatar",
}

const PhotoSelectionBtn: React.FC<Props> = ({ selected, onClick, source}) => {
    const defaultBtnClasses = "fill-current text-[#DC3545] hover:shadow-[2px_2px_10px_rgba(0,0,0,0.25)] flex justify-center items-center w-[41px] h-[41px] rounded-full transition-shadow ease-in-out duration-200"
    const selectedBtnClasses = "fill-white bg-[#DC3545] shadow-[2px_2px_10px_rgba(0,0,0,0.25)] flex justify-center items-center w-[41px] h-[41px] rounded-full";
    const Svg = source === PhotoSource.AVATAR ? Avatar : (source === PhotoSource.CAMERA ? Camera : Img);

    return (
        <>
            <button type="button" onClick={onClick} className={selected ? selectedBtnClasses : defaultBtnClasses}>
                <Svg/>
            </button>
            <p className="text-[12px] font-light leading-[15px] m-0"><T path={`games.players.add.${source}`} /></p>
        </>
    )
};

export default PhotoSelectionBtn;
